import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ChangeCardStatusMutationArgs } from '../Cards.types';

import { QUERY_KEYS } from './useGetCards.query';

export const useChangeCardStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation(
    (data: ChangeCardStatusMutationArgs) =>
      api.put(API_URL.CARDS_BY_CARD_ID(data.id), {
        status: data.status,
        locked_purse_ids: data.lockedPursesIds,
        employee_unlock_forbidden: data.isEmployeeUnlockForbidden,
        lock_reason: data.lockReason || undefined,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey[0] === QUERY_KEYS.GET_CARDS_HOLDERS
            || query.queryKey[0] === QUERY_KEYS.GET_CARDS_PURSES,
        });
      },
    }
  );
  return {
    mutateAsync,
    isPending,
  };
};
